<script lang="ts" setup>
import { computed, useCssModule } from "vue";

import { useTIWStore } from "@/stores/tiw/tiw";

const classes = useCssModule();

const TIWStore = useTIWStore();

const color = computed(
    () => TIWStore.customStyles.color.main || "var(--custom-color-main, #6959cb)",
);
</script>

<template>
    <svg data-component="loader"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
        width="200"
        height="200"
        style="shape-rendering: auto; display: block; background: transparent"
        :class="[classes.rotation]"
        v-bind="$attrs"
    >
        <circle
            cx="50"
            cy="50"
            r="38"
            fill="none"
            :stroke="color"
            stroke-width="8"
            stroke-dasharray="160 80"
            stroke-linecap="round"
            opacity="0.8"
        />
    </svg>
</template>

<style module>
.rotation {
    animation: tiw-spin 0.8s linear infinite;
    transform-origin: center;
}

@keyframes tiw-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
